export default {"src":"/_next/static/media/arrow-right-circle.419ed852.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};